import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SasSurveyService {

  private _tmpId: number;

  set tmpId(id: number) {
    this._tmpId = id;
  }

  get tmpId(): number {
    return this._tmpId;
  }

}
